export default __webpack_public_path__ + "static/media/gift.522eb54c.svg";